import React from 'react'
import HighlightItem from './HighlightItem'

function FeaturesList() {
  return (
    <>
      <div className="account-subscription__line" />
      <div className="account-subscription__highlights">
        <p className="account-subscription__highlights-title">Особенности подписки</p>
        <ul className="account-subscription__highlights-list">
          {[
            'Подписка продлевается автоматически, если ее не отменить. После отмены она продолжает действовать до конца оплаченного срока',
            'Поменять вариант подписки можно в любой момент, изменения вступят в силу после завершения текущего оплаченного периода',
            'Оформить такую же подписку, какая у вас действует сейчас, нельзя, но можно выбрать другую',
            'Если у вас уже оформлена подписка через App Store и вы хотите купить новую у нас на сайте, отмените подписку в личном кабинете магазина приложений. Если этого не сделать, у вас будут действовать две подписки одновременно, оплата будет списываться за обе'
          ].map((item, index) => (
            <HighlightItem {...{ item }} key={index} />
          ))}
        </ul>
      </div>{' '}
    </>
  )
}

export default React.memo(FeaturesList)
